import React from "react"

const SaZipperPuller = ({ showSoft, showPattern, fillColor, strokeColor }) => (
  <g id="zipper_puller">
    {showSoft ? (
      <g id="zipper_puller_soft">
        <path d="M161 230.7c.2.2.3.4.3.7.024.094.047.189.072.283.176-.049.352-.083.528-.083.4 0 1 0 1.2.4.3.3.2.8.2 1.3 0 .629.11 1.23.258 1.819l.142-.219c.2-.2.4-.5.7-.6.4-.1.9 0 1.2.3.3.3.5.8.5 1.2.025.245.019.49-.008.736a.647.647 0 01.408-.136c.5 0 .7.4.9.8.2.3.3.6.4.9.195.52.095.87 0 1.298.698.16 1.807.585 2.8 1.702 1.6 1.9 7.3 7.8 10.7 12 2.4 3 4.5 4.5 5.5 5.1l1.2.9 6.3 5.5-.022.043a.228.228 0 01.122-.043l.3-.3c.6-.5 1.4-.7 2.1-.6 2.036.388 1.158 2.844 1.011 3.175l-.011.025h-.5c-1-.1-1.7.3-2.2.9-.08.08-.16.16-.189.24l-.011.06-.059.104.046.006c.064-.07.113-.14.113-.21.5-.6 1.2-.9 2.2-.9h.5c2.6 1.2 7.2 3.9 10 6.3 2.5 2.1 2.9 4.3 2.9 5.6-.9.2-1.5.6-1.8 1.1h-.1c0-.098.096-.196.1-.387v-.013c0 .1-.1.3-.1.4-.1.4-.3.7-.6.9-.8.8-2 .9-3 .8-.7-.1-1.5-.3-2.1-.7l-9.3-5.7c-.9-.6-1.7-1.3-2.1-2.3-.3-.5-.4-1-.5-1.5-.1-.6-.1-1.3 0-1.9 0-.1.1-.3.1-.4.18-.631.442-1.263.712-1.82l-.012.02c-.4.6-.7 1.3-.8 2-.5-.4-1.3-1-2.1-1.7-.3-.2-.5-.5-.8-.7l-.25-.25-.25-.25c-1.8-1.8-8.3-6.6-9.8-9.2-1.5-2.6-10-12.6-11.3-13.6l-.102-.077c-.11.155-.16.298-.398.377-.2.1-.5.1-.7.1-.9.1-1-.7-1.8-.8-.6-.1-1.4-.5-1.3-.8a.692.692 0 01.157-.2h-.357c-.3-.1-.7-.1-.9-.4-.1-.1-.2-.3-.2-.4a2.34 2.34 0 01-.147-.605c-.121.005-.241.005-.353.005h-.1c-.164-.003-.317-.017-.4-.1-.1-.1-.1-.2-.2-.3-.2-.4-.3-1.5.2-1.8a.715.715 0 01.007-.003l-.107-.097c-.4-.4-.6-1.2-.3-1.8 0-.1.1-.2.2-.3.1-.1.3-.1.4-.1.027 0 .055 0 .082.002a3.515 3.515 0 00-.782-1.802c-.1-.2-.3-.3-.3-.5v-.5c0-.6-.5-1-.8-1.6-.1-.2-.2-.5-.3-.8v-.2c0-.1.1-.1.1-.1.5-.2.9-.4 1.4-.6.5-.1 1.1-.1 1.4.3zm32.855 39.968l-.025.128a1.72 1.72 0 00-.03.304c-.1.6-.1 1.1-.1 1.1l13.2 6.7a.372.372 0 00.044-.195l-.344-.205c-.84-2.519-11.338-7.213-12.745-7.832zm2.984-1.795l.124.052c2.092.885 5.166 2.455 7.592 4.014-2.498-1.638-5.651-3.241-7.716-4.066z" fill={fillColor} fillRule="nonzero"/>
        <g style={{visibility: showPattern ? 'visible': 'hidden'}} transform="translate(158 230)">
          <mask id="z" fill="#fff">
            <use xlinkHref="#y"/>
          </mask>
          <g fill="#FFF" fillRule="nonzero" mask="url(#z)">
            <g transform="translate(0 -1)">
              <circle cx="1.4" cy="1.4" r="0.5"/>
              <circle cx="1.4" cy="3.9" r="0.5"/>
              <circle cx="1.4" cy="6.4" r="0.5"/>
              <circle cx="1.4" cy="8.9" r="0.5"/>
              <circle cx="1.4" cy="11.4" r="0.5"/>
              <circle cx="1.4" cy="13.9" r="0.5"/>
              <circle cx="1.4" cy="16.4" r="0.5"/>
              <circle cx="1.4" cy="18.9" r="0.5"/>
              <circle cx="3.9" cy="1.4" r="0.5"/>
              <circle cx="3.9" cy="3.9" r="0.5"/>
              <circle cx="3.9" cy="6.4" r="0.5"/>
              <circle cx="3.9" cy="8.9" r="0.5"/>
              <circle cx="3.9" cy="11.4" r="0.5"/>
              <circle cx="3.9" cy="13.9" r="0.5"/>
              <circle cx="3.9" cy="16.4" r="0.5"/>
              <circle cx="3.9" cy="18.9" r="0.5"/>
              <circle cx="6.4" cy="1.4" r="0.5"/>
              <circle cx="6.4" cy="3.9" r="0.5"/>
              <circle cx="6.4" cy="6.4" r="0.5"/>
              <circle cx="6.4" cy="8.9" r="0.5"/>
              <circle cx="6.4" cy="11.4" r="0.5"/>
              <circle cx="6.4" cy="13.9" r="0.5"/>
              <circle cx="6.4" cy="16.4" r="0.5"/>
              <circle cx="6.4" cy="18.9" r="0.5"/>
              <circle cx="8.9" cy="1.4" r="0.5"/>
              <circle cx="8.9" cy="3.9" r="0.5"/>
              <circle cx="8.9" cy="6.4" r="0.5"/>
              <circle cx="8.9" cy="8.9" r="0.5"/>
              <circle cx="8.9" cy="11.4" r="0.5"/>
              <circle cx="8.9" cy="13.9" r="0.5"/>
              <circle cx="8.9" cy="16.4" r="0.5"/>
              <circle cx="8.9" cy="18.9" r="0.5"/>
              <circle cx="11.4" cy="1.4" r="0.5"/>
              <circle cx="11.4" cy="3.9" r="0.5"/>
              <circle cx="11.4" cy="6.4" r="0.5"/>
              <circle cx="11.4" cy="8.9" r="0.5"/>
              <circle cx="11.4" cy="11.4" r="0.5"/>
              <circle cx="11.4" cy="13.9" r="0.5"/>
              <circle cx="11.4" cy="16.4" r="0.5"/>
              <circle cx="11.4" cy="18.9" r="0.5"/>
              <circle cx="13.9" cy="1.4" r="0.5"/>
              <circle cx="13.9" cy="3.9" r="0.5"/>
              <circle cx="13.9" cy="6.4" r="0.5"/>
              <circle cx="13.9" cy="8.9" r="0.5"/>
              <circle cx="13.9" cy="11.4" r="0.5"/>
              <circle cx="13.9" cy="13.9" r="0.5"/>
              <circle cx="13.9" cy="16.4" r="0.5"/>
              <circle cx="13.9" cy="18.9" r="0.5"/>
              <circle cx="16.4" cy="1.4" r="0.5"/>
              <circle cx="16.4" cy="3.9" r="0.5"/>
              <circle cx="16.4" cy="6.4" r="0.5"/>
              <circle cx="16.4" cy="8.9" r="0.5"/>
              <circle cx="16.4" cy="11.4" r="0.5"/>
              <circle cx="16.4" cy="13.9" r="0.5"/>
              <circle cx="16.4" cy="16.4" r="0.5"/>
              <circle cx="16.4" cy="18.9" r="0.5"/>
              <circle cx="18.9" cy="1.4" r="0.5"/>
              <circle cx="18.9" cy="3.9" r="0.5"/>
              <circle cx="18.9" cy="6.4" r="0.5"/>
              <circle cx="18.9" cy="8.9" r="0.5"/>
              <circle cx="18.9" cy="11.4" r="0.5"/>
              <circle cx="18.9" cy="13.9" r="0.5"/>
              <circle cx="18.9" cy="16.4" r="0.5"/>
              <circle cx="18.9" cy="18.9" r="0.5"/>
            </g>
            <g transform="translate(15 19)">
              <circle cx="1.4" cy="1.4" r="0.5"/>
              <circle cx="1.4" cy="3.9" r="0.5"/>
              <circle cx="1.4" cy="6.4" r="0.5"/>
              <circle cx="1.4" cy="8.9" r="0.5"/>
              <circle cx="1.4" cy="11.4" r="0.5"/>
              <circle cx="1.4" cy="13.9" r="0.5"/>
              <circle cx="1.4" cy="16.4" r="0.5"/>
              <circle cx="1.4" cy="18.9" r="0.5"/>
              <circle cx="3.9" cy="1.4" r="0.5"/>
              <circle cx="3.9" cy="3.9" r="0.5"/>
              <circle cx="3.9" cy="6.4" r="0.5"/>
              <circle cx="3.9" cy="8.9" r="0.5"/>
              <circle cx="3.9" cy="11.4" r="0.5"/>
              <circle cx="3.9" cy="13.9" r="0.5"/>
              <circle cx="3.9" cy="16.4" r="0.5"/>
              <circle cx="3.9" cy="18.9" r="0.5"/>
              <circle cx="6.4" cy="1.4" r="0.5"/>
              <circle cx="6.4" cy="3.9" r="0.5"/>
              <circle cx="6.4" cy="6.4" r="0.5"/>
              <circle cx="6.4" cy="8.9" r="0.5"/>
              <circle cx="6.4" cy="11.4" r="0.5"/>
              <circle cx="6.4" cy="13.9" r="0.5"/>
              <circle cx="6.4" cy="16.4" r="0.5"/>
              <circle cx="6.4" cy="18.9" r="0.5"/>
              <circle cx="8.9" cy="1.4" r="0.5"/>
              <circle cx="8.9" cy="3.9" r="0.5"/>
              <circle cx="8.9" cy="6.4" r="0.5"/>
              <circle cx="8.9" cy="8.9" r="0.5"/>
              <circle cx="8.9" cy="11.4" r="0.5"/>
              <circle cx="8.9" cy="13.9" r="0.5"/>
              <circle cx="8.9" cy="16.4" r="0.5"/>
              <circle cx="8.9" cy="18.9" r="0.5"/>
              <circle cx="11.4" cy="1.4" r="0.5"/>
              <circle cx="11.4" cy="3.9" r="0.5"/>
              <circle cx="11.4" cy="6.4" r="0.5"/>
              <circle cx="11.4" cy="8.9" r="0.5"/>
              <circle cx="11.4" cy="11.4" r="0.5"/>
              <circle cx="11.4" cy="13.9" r="0.5"/>
              <circle cx="11.4" cy="16.4" r="0.5"/>
              <circle cx="11.4" cy="18.9" r="0.5"/>
              <circle cx="13.9" cy="1.4" r="0.5"/>
              <circle cx="13.9" cy="3.9" r="0.5"/>
              <circle cx="13.9" cy="6.4" r="0.5"/>
              <circle cx="13.9" cy="8.9" r="0.5"/>
              <circle cx="13.9" cy="11.4" r="0.5"/>
              <circle cx="13.9" cy="13.9" r="0.5"/>
              <circle cx="13.9" cy="16.4" r="0.5"/>
              <circle cx="13.9" cy="18.9" r="0.5"/>
              <circle cx="16.4" cy="1.4" r="0.5"/>
              <circle cx="16.4" cy="3.9" r="0.5"/>
              <circle cx="16.4" cy="6.4" r="0.5"/>
              <circle cx="16.4" cy="8.9" r="0.5"/>
              <circle cx="16.4" cy="11.4" r="0.5"/>
              <circle cx="16.4" cy="13.9" r="0.5"/>
              <circle cx="16.4" cy="16.4" r="0.5"/>
              <circle cx="16.4" cy="18.9" r="0.5"/>
              <circle cx="18.9" cy="1.4" r="0.5"/>
              <circle cx="18.9" cy="3.9" r="0.5"/>
              <circle cx="18.9" cy="6.4" r="0.5"/>
              <circle cx="18.9" cy="8.9" r="0.5"/>
              <circle cx="18.9" cy="11.4" r="0.5"/>
              <circle cx="18.9" cy="13.9" r="0.5"/>
              <circle cx="18.9" cy="16.4" r="0.5"/>
              <circle cx="18.9" cy="18.9" r="0.5"/>
            </g>
            <g transform="translate(35 32)">
              <circle cx="1.4" cy="1.4" r="0.5"/>
              <circle cx="1.4" cy="3.9" r="0.5"/>
              <circle cx="1.4" cy="6.4" r="0.5"/>
              <circle cx="1.4" cy="8.9" r="0.5"/>
              <circle cx="1.4" cy="11.4" r="0.5"/>
              <circle cx="1.4" cy="13.9" r="0.5"/>
              <circle cx="1.4" cy="16.4" r="0.5"/>
              <circle cx="1.4" cy="18.9" r="0.5"/>
              <circle cx="3.9" cy="1.4" r="0.5"/>
              <circle cx="3.9" cy="3.9" r="0.5"/>
              <circle cx="3.9" cy="6.4" r="0.5"/>
              <circle cx="3.9" cy="8.9" r="0.5"/>
              <circle cx="3.9" cy="11.4" r="0.5"/>
              <circle cx="3.9" cy="13.9" r="0.5"/>
              <circle cx="3.9" cy="16.4" r="0.5"/>
              <circle cx="3.9" cy="18.9" r="0.5"/>
              <circle cx="6.4" cy="1.4" r="0.5"/>
              <circle cx="6.4" cy="3.9" r="0.5"/>
              <circle cx="6.4" cy="6.4" r="0.5"/>
              <circle cx="6.4" cy="8.9" r="0.5"/>
              <circle cx="6.4" cy="11.4" r="0.5"/>
              <circle cx="6.4" cy="13.9" r="0.5"/>
              <circle cx="6.4" cy="16.4" r="0.5"/>
              <circle cx="6.4" cy="18.9" r="0.5"/>
              <circle cx="8.9" cy="1.4" r="0.5"/>
              <circle cx="8.9" cy="3.9" r="0.5"/>
              <circle cx="8.9" cy="6.4" r="0.5"/>
              <circle cx="8.9" cy="8.9" r="0.5"/>
              <circle cx="8.9" cy="11.4" r="0.5"/>
              <circle cx="8.9" cy="13.9" r="0.5"/>
              <circle cx="8.9" cy="16.4" r="0.5"/>
              <circle cx="8.9" cy="18.9" r="0.5"/>
              <circle cx="11.4" cy="1.4" r="0.5"/>
              <circle cx="11.4" cy="3.9" r="0.5"/>
              <circle cx="11.4" cy="6.4" r="0.5"/>
              <circle cx="11.4" cy="8.9" r="0.5"/>
              <circle cx="11.4" cy="11.4" r="0.5"/>
              <circle cx="11.4" cy="13.9" r="0.5"/>
              <circle cx="11.4" cy="16.4" r="0.5"/>
              <circle cx="11.4" cy="18.9" r="0.5"/>
              <circle cx="13.9" cy="1.4" r="0.5"/>
              <circle cx="13.9" cy="3.9" r="0.5"/>
              <circle cx="13.9" cy="6.4" r="0.5"/>
              <circle cx="13.9" cy="8.9" r="0.5"/>
              <circle cx="13.9" cy="11.4" r="0.5"/>
              <circle cx="13.9" cy="13.9" r="0.5"/>
              <circle cx="13.9" cy="16.4" r="0.5"/>
              <circle cx="13.9" cy="18.9" r="0.5"/>
              <circle cx="16.4" cy="1.4" r="0.5"/>
              <circle cx="16.4" cy="3.9" r="0.5"/>
              <circle cx="16.4" cy="6.4" r="0.5"/>
              <circle cx="16.4" cy="8.9" r="0.5"/>
              <circle cx="16.4" cy="11.4" r="0.5"/>
              <circle cx="16.4" cy="13.9" r="0.5"/>
              <circle cx="16.4" cy="16.4" r="0.5"/>
              <circle cx="16.4" cy="18.9" r="0.5"/>
              <circle cx="18.9" cy="1.4" r="0.5"/>
              <circle cx="18.9" cy="3.9" r="0.5"/>
              <circle cx="18.9" cy="6.4" r="0.5"/>
              <circle cx="18.9" cy="8.9" r="0.5"/>
              <circle cx="18.9" cy="11.4" r="0.5"/>
              <circle cx="18.9" cy="13.9" r="0.5"/>
              <circle cx="18.9" cy="16.4" r="0.5"/>
              <circle cx="18.9" cy="18.9" r="0.5"/>
            </g>
          </g>
        </g>
        <g fillRule="nonzero" stroke="#231F20" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5">
          <path d="M161 230.7c.2.2.3.4.3.7.024.094.047.189.072.283-.124.034-.248.076-.372.117-.3.1-.6.3-.7.6-.1.4 0 .9.2 1.3.3.5.6.9.8 1.4.2.3.2.7.2 1 .038.154.047.41.044.692-.415-.113-.824-.272-1.262-.29a3.522 3.522 0 00-.782-1.802c-.1-.2-.3-.3-.3-.5v-.5h0c0-.6-.5-1-.8-1.6-.1-.2-.2-.5-.3-.8v-.2h0c0-.1.1-.1.1-.1.5-.2.9-.4 1.4-.6.5-.1 1.1-.1 1.4.3zM210.6 279c-.9.2-1.5.6-1.8 1.1h-.1c0-.1.1-.2.1-.4 0 0 1-2.9-2.6-5.6-3.5-2.7-10-5.8-11.3-5.8h-.1c.1-.1.2-.2.2-.3.5-.6 1.2-.9 2.2-.9h.5c2.6 1.2 7.2 3.9 10 6.3 2.5 2.1 2.9 4.3 2.9 5.6z"/>
          <path d="M208.8 279.7c0 .1-.1.3-.1.4-.1.4-.3.7-.6.9-.8.8-2 .9-3 .8-.7-.1-1.5-.3-2.1-.7l-9.3-5.7c-.9-.6-1.7-1.3-2.1-2.3-.3-.5-.4-1-.5-1.5-.1-.6-.1-1.3 0-1.9 0-.1.1-.3.1-.4.2-.7.5-1.4.8-2 .1-.2.3-.4.4-.6 0-.1.1-.1.1-.2l.1-.1.1-.1c.2-.3.5-.6.8-.9 0-.1.1-.1.2-.2l.3-.3.1-.1c.1-.1.2-.2.3-.2l.3-.3c.6-.5 1.4-.7 2.1-.6 2.1.4 1.1 3 1 3.2h0-.5c-1-.1-1.7.3-2.2.9-.1.1-.2.2-.2.3h0c-.1.2-.2.3-.3.5-.3.5-.4 1-.6 1.5-.1.4-.2.7-.2 1-.1.6-.1 1.1-.1 1.1l13.2 6.7c.1-.2 0-.3 0-.5l1 .6.9.7z"/>
          <path d="M208.8 279.7l-1.2-.6-1-.6c-.9-2.7-12.9-7.9-12.9-7.9l.1-.4c.1-.5.3-1 .6-1.5l.3-.5h.1c1.3.1 7.8 3.2 11.3 5.8 3.7 2.8 2.7 5.7 2.7 5.7zM170.6 241.1c1.6 1.9 7.3 7.8 10.7 12 2.4 3 4.5 4.5 5.5 5.1l1.2.9h0l6.3 5.5-.1.2c-.1.1-.2.2-.3.2l-.1.1-.3.3-.2.2c-.3.3-.5.6-.8.9l-.1.1-.1.1c0 .1-.1.1-.1.2l-5.8-5.6c-.4-.4-.8-.7-1.2-.9-1-.6-3-2.1-5.4-5.2-3.3-4.3-8.5-10.3-10-12.2-.7-.91-1.5-1.38-2.155-1.613.055-.342.055-.863.055-1.187 0-.316.05-.57.1-.802.697.16 1.806.584 2.8 1.702z"/>
          <path d="M169.9 243c1.5 1.9 6.7 8 10 12.2 2.4 3.1 4.4 4.6 5.4 5.2l1.2.9h0l5.8 5.6c-.1.2-.3.4-.4.6-.4.6-.7 1.3-.8 2-.5-.4-1.3-1-2.1-1.7-.3-.2-.5-.5-.8-.7l-.5-.5c-1.8-1.8-8.3-6.6-9.8-9.2-1.5-2.6-10-12.6-11.3-13.6l-.102-.078a.934.934 0 01.102-.122c.5-.5.8-1.3 1-2 .02-.061.037-.139.05-.227.67.24 1.515.744 2.25 1.627z"/>
          <path d="M166.5 236.4c.5 0 .7.4.9.8.2.3.3.6.4.9.3.8-.1 1.2-.1 2.1 0 .4 0 1.1-.1 1.4-.2.7-.5 1.5-1 2-.2.2-.2.4-.5.5-.2.1-.5.1-.7.1-.9.1-1-.7-1.8-.8-.6-.1-1.4-.5-1.3-.8a.691.691 0 01.156-.2h.344c.5-.1.9-.4 1.2-.8.7-.8 1.1-1.8 1.5-2.8.226-.755.51-1.51.592-2.264a.647.647 0 01.408-.136zM160.008 238.797l-.108-.097c.383.383.883.531 1.365.535-.158.235-.309.484-.365.765a3.28 3.28 0 00-.047.995c-.121.005-.241.005-.353.005-.2 0-.4 0-.5-.1-.1-.1-.1-.2-.2-.3-.2-.4-.3-1.5.2-1.8a.716.716 0 01.008-.003zM163.1 232c.3.3.2.8.2 1.3 0 .63.11 1.231.258 1.82l.142-.22a30.795 30.795 0 00-1.209 1.999c-.305.04-.604-.013-.9-.092a3.41 3.41 0 00-.091-.707c0-.3 0-.7-.2-1-.2-.5-.5-.9-.8-1.4-.2-.4-.3-.9-.2-1.3.1-.3.4-.5.7-.6.3-.1.6-.2.9-.2.4 0 1 0 1.2.4z"/>
          <path d="M160.2 236.5c.8 0 1.5.5 2.3.4-.14.233-.27.466-.4.7-.2.4-.3.7-.5 1.1-.088.175-.214.35-.336.534-.482-.003-.982-.152-1.364-.534-.4-.4-.6-1.2-.3-1.8 0-.1.1-.2.2-.3.1-.1.3-.1.4-.1z"/>
          <path d="M166.1 235.8c0-.4-.2-.9-.5-1.2-.3-.3-.8-.4-1.2-.3-.3.1-.5.4-.7.6-.6.9-1.1 1.8-1.6 2.7-.2.4-.3.7-.5 1.1-.2.4-.6.8-.7 1.3-.1.5-.1 1.1.1 1.6 0 .1.1.3.2.4.2.3.6.3.9.4h.7c.5-.1.9-.4 1.2-.8.7-.8 1.1-1.8 1.5-2.8.3-1 .7-2 .6-3zM162.7 232c.1 0 .2.1.2.1.1.2 0 .4-.1.5-.1.1-.4.2-.5.3-.2.1-.4.4-.7.4h-.3c-.1 0-.1 0-.1.1l.1.1c.5.1 1 .1 1.4-.1.3-.1.5-.4.6-.7.1-.3 0-.6-.3-.8-.1-.1-.3-.1-.4-.1-.2 0-.3-.1-.5 0 .1.1.4.1.6.2zM159.1 232.4c.2 0 .4-.1.6-.3.2-.2.2-.5.4-.6.1-.1.3 0 .4-.1.1-.1.1-.3.1-.4-.5-.5-1.6-.1-2.1.3-.2.2-.3.4-.2.7.2.3.4.5.8.4z"/>
        </g>
        <g fillRule="nonzero">
          <g stroke="#30292B" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".324">
            <path d="M35.81 17.4l-6.6-.1-3.9-.2c-.5-.3-3.9-.4-3.9-.4l-.6-.5 10.9.3 4.1.9z" fill="url(#e)" transform="translate(187.49 266.9)"/>
            <path d="M24.31 15.7l-3.5.1s-.5-3.2 2.3-3.7 5.8-.2 7.6 0c1.4.2 4.6 1.4 4.2 5l-3.5.1s1.3-2.5-1.5-3.4c.1 0-5.3-1.3-5.6 1.9z" fill="url(#f)" transform="translate(187.49 266.9)"/>
            <path fill="url(#g)" d="M21.41 16.6v2.6h-.6v-3.1z" transform="translate(187.49 266.9)"/>
            <path d="M23.51 16.7l.1 2.8c-.2 0-.4-.1-.5-.1l-1.7-.2v-2.6s1.1.1 2.1.1z" fill="url(#h)" transform="translate(187.49 266.9)"/>
            <path d="M25.31 17l.1 2.8c-.7 0-1.3-.1-1.8-.2l-.1-2.8c.8 0 1.6.1 1.8.2z" fill="url(#i)" transform="translate(187.49 266.9)"/>
            <path fill="url(#j)" d="M35.81 17.4v.9l-6.3.1v1.5h-.5l-.1-2.7h.3z" transform="translate(187.49 266.9)"/>
            <path d="M28.91 17.2l.1 2.7h-.3s-1.8 0-3.4-.1l-.1-2.8 3.7.2z" fill="url(#k)" transform="translate(187.49 266.9)"/>
            <path d="M25.91 15.5c-1.5.6-4.1-.7-4.1-.7l-1.2-.7-15.9-8.7s-.5-.3-1.2-.7C2.21 4 .41 2.8.11 2.2c-.4-.8.4-1.9.6-2.2.3.2.5.5.8.7.2 1 1.6 1.9 1.6 1.9l.4.2 2.6 1.5 13 7.2 2.2 1.2 2.7 1.5c.5.3.9 0 .9 0l.9.5c.6.4.1.8.1.8z" fill="url(#A)" transform="translate(187.49 266.9)"/>
          </g>
          <path d="M11.772 4.426h0v-.1c0-.5-.1-1.4-.6-1.9-.6-.6-2.3-2.5-4-2.4 0 0-.6-.1-1.5.6-.8.7-4 .3-4 .3s-.2 1.2-.2 3.3h0v.2h0c0 1.7.2 3.3.2 3.3s3.2-.4 4 .3c.8.7 1.5.6 1.5.6 1.7.1 3.4-1.8 4-2.4.5-.5.5-1.4.6-1.9v.1s0 0 0 0z" stroke="#30292B" strokeWidth=".324" fill="url(#n)" strokeLinecap="round" strokeLinejoin="round" transform="translate(202.628 306.774)"/>
          <path d="M8.872.426c-.3-.1-.7-.2-1.1-.1 0 0-.7-.1-1.6.6-.7.6-3.3.5-4.6.4 0-.2.1-.4.1-.4s3.2.4 4-.3c.8-.7 1.5-.6 1.5-.6.6-.1 1.2.1 1.7.4z" stroke="#30292B" strokeWidth=".324" fill="url(#o)" strokeLinecap="round" strokeLinejoin="round" transform="translate(202.628 306.774)"/>
          <path d="M10.972 3.526v2.7c-.2 0-.6.1-1.1.1v-.1h0c.1-1.1-.2-2.1-.9-2.7h2z" stroke="#30292B" strokeWidth=".324" fill="url(#p)" strokeLinecap="round" strokeLinejoin="round" transform="translate(202.628 306.774)"/>
          <path d="M207 330.3s1.9-.1 2 2.1l2.5-17.3-2.2.8-2.3 14.4z" stroke="#231F20" strokeWidth=".14" fill="#FFF"/>
          <path d="M8.972 3.426c-.3-.4-.8-.6-1.3-.7-.7-.1-1.4.1-2 .6-.5.5-.9 1.1-1.1 1.9h0l-.2 1-4.2 18.6-.1.6c-.4 2.6.9 4.9 3 5.3 1.8.3 3.5-1 4.3-3 .1-.3.2-.7.3-1.1l.1-.6.3-2.3 2-17.6v-.1h0c-.1-.9-.5-1.9-1.1-2.6zm-.2 2.9v.3h0l-2.3 19.1-.1.6c-.4 2.5-2 4.2-3.6 4-1.6-.3-2.5-2.5-2.1-4.9l.1-.6 4-18.4.1-.4h0c.3-1.3 1.1-2.3 1.9-2.5.2 0 .4-.1.6 0h.2c.7.2 1.2 1.4 1.2 2.8z" stroke="#30292B" strokeWidth=".324" fill="url(#B)" strokeLinecap="round" strokeLinejoin="round" transform="translate(202.628 306.774)"/>
          <path d="M6.172 3.626c-.3.4-.6 1-.8 1.7h0l-4 18.8-.1.6c-.4 2.5.5 4.7 2.1 4.9.6.1 1.1-.1 1.6-.4-.7.8-1.5 1.2-2.3 1.1-1.6-.3-2.5-2.5-2.1-4.9l.1-.6 4-18.8h0c.3-1.2.9-2 1.5-2.4z" stroke="#30292B" strokeWidth=".324" fill="url(#C)" strokeLinecap="round" strokeLinejoin="round" transform="translate(202.628 306.774)"/>
          <path d="M8.772 6.326h-4.4c-1.5-.1-2.5-.5-2.5-.5-.2-.8-.1-2.6-.1-2.6.8.1 2.4.2 4 .2h1.6c.9.3 1.4 1.5 1.4 2.9z" stroke="#30292B" strokeWidth=".324" fill="url(#u)" strokeLinecap="round" strokeLinejoin="round" transform="translate(202.628 306.774)"/>
        </g>
        <g>
          <path d="M211.3 313.4l-.3 2.3c-.8.3-1.7 3-1.8 4.3-.1 1.4-.8 4.8-1.2 8.8-.3 2.9.5 3.5.9 3.6v.2l-.1.6a7.776 7.776 0 01-.354 1.314l.054.186c1.3 4.6-1.5 17.5-1.5 17.5s-1.5 7.9-1.6 13.6c0 2.839-.839 5.223-1.695 6.917.285.477.78 1.465.88 2.705 1.355 1.774 1.066 4.656-1.28 5.575.296.62.64 1.429.795 2.103.3 1.2-2.6 2-2.3 1.4.29-.436-.476-2.353-.916-3.366-1.216-.405-1.676-1.565-1.823-2.081-.818-.48-1.477-1.42-1.744-2.999-.12 0-.414-.16-1.117-1.054-1-1.5.8-1.8.8-1.8.15.599.326 1.09.495 1.479l.045-.035c-.29-.68-.505-1.435-.64-2.144-.4-2 1.9-2.3 1.9-2.3 0 .19.022.355.061.503C198.701 360.214 204.7 339 204.7 339l1.156-5.641v-.048c-.389.202-.932.314-1.756.089-1.9-.5-.3-5.8 0-9.6s1.1-6.9 1.1-6.9c1.245-3.832 3.867-2.892 4.085-2.806l-.085.106c1-1.3 2-.9 2.1-.8zm-.7 17.2c.9.5 1 1.5 1 1.5.1 1.7-.9 2.3-1.7 2.5.1-.3.2-.7.3-1.1l.1-.6.3-2.3zm1.7-16.4c.4.4 1.6 1.6 1.3 3.5-.2 1.7-1.9 6.7-2.7 9.1l1.4-12.6z" fill={fillColor} fillRule="nonzero"/>
          <g style={{visibility: showPattern ? 'visible': 'hidden'}} transform="translate(195 313)">
            <mask id="E" fill="#fff">
              <use xlinkHref="#D"/>
            </mask>
            <g fill="#FFF" fillRule="nonzero" mask="url(#E)">
              <g transform="rotate(45 -52.355 30.172)">
                <circle cx="1.4" cy="1.4" r="0.5"/>
                <circle cx="1.4" cy="3.9" r="0.5"/>
                <circle cx="1.4" cy="6.4" r="0.5"/>
                <circle cx="1.4" cy="8.9" r="0.5"/>
                <circle cx="1.4" cy="11.4" r="0.5"/>
                <circle cx="1.4" cy="13.9" r="0.5"/>
                <circle cx="1.4" cy="16.4" r="0.5"/>
                <circle cx="1.4" cy="18.9" r="0.5"/>
                <circle cx="3.9" cy="1.4" r="0.5"/>
                <circle cx="3.9" cy="3.9" r="0.5"/>
                <circle cx="3.9" cy="6.4" r="0.5"/>
                <circle cx="3.9" cy="8.9" r="0.5"/>
                <circle cx="3.9" cy="11.4" r="0.5"/>
                <circle cx="3.9" cy="13.9" r="0.5"/>
                <circle cx="3.9" cy="16.4" r="0.5"/>
                <circle cx="3.9" cy="18.9" r="0.5"/>
                <circle cx="6.4" cy="1.4" r="0.5"/>
                <circle cx="6.4" cy="3.9" r="0.5"/>
                <circle cx="6.4" cy="6.4" r="0.5"/>
                <circle cx="6.4" cy="8.9" r="0.5"/>
                <circle cx="6.4" cy="11.4" r="0.5"/>
                <circle cx="6.4" cy="13.9" r="0.5"/>
                <circle cx="6.4" cy="16.4" r="0.5"/>
                <circle cx="6.4" cy="18.9" r="0.5"/>
                <circle cx="8.9" cy="1.4" r="0.5"/>
                <circle cx="8.9" cy="3.9" r="0.5"/>
                <circle cx="8.9" cy="6.4" r="0.5"/>
                <circle cx="8.9" cy="8.9" r="0.5"/>
                <circle cx="8.9" cy="11.4" r="0.5"/>
                <circle cx="8.9" cy="13.9" r="0.5"/>
                <circle cx="8.9" cy="16.4" r="0.5"/>
                <circle cx="8.9" cy="18.9" r="0.5"/>
                <circle cx="11.4" cy="1.4" r="0.5"/>
                <circle cx="11.4" cy="3.9" r="0.5"/>
                <circle cx="11.4" cy="6.4" r="0.5"/>
                <circle cx="11.4" cy="8.9" r="0.5"/>
                <circle cx="11.4" cy="11.4" r="0.5"/>
                <circle cx="11.4" cy="13.9" r="0.5"/>
                <circle cx="11.4" cy="16.4" r="0.5"/>
                <circle cx="11.4" cy="18.9" r="0.5"/>
                <circle cx="13.9" cy="1.4" r="0.5"/>
                <circle cx="13.9" cy="3.9" r="0.5"/>
                <circle cx="13.9" cy="6.4" r="0.5"/>
                <circle cx="13.9" cy="8.9" r="0.5"/>
                <circle cx="13.9" cy="11.4" r="0.5"/>
                <circle cx="13.9" cy="13.9" r="0.5"/>
                <circle cx="13.9" cy="16.4" r="0.5"/>
                <circle cx="13.9" cy="18.9" r="0.5"/>
                <circle cx="16.4" cy="1.4" r="0.5"/>
                <circle cx="16.4" cy="3.9" r="0.5"/>
                <circle cx="16.4" cy="6.4" r="0.5"/>
                <circle cx="16.4" cy="8.9" r="0.5"/>
                <circle cx="16.4" cy="11.4" r="0.5"/>
                <circle cx="16.4" cy="13.9" r="0.5"/>
                <circle cx="16.4" cy="16.4" r="0.5"/>
                <circle cx="16.4" cy="18.9" r="0.5"/>
                <circle cx="18.9" cy="1.4" r="0.5"/>
                <circle cx="18.9" cy="3.9" r="0.5"/>
                <circle cx="18.9" cy="6.4" r="0.5"/>
                <circle cx="18.9" cy="8.9" r="0.5"/>
                <circle cx="18.9" cy="11.4" r="0.5"/>
                <circle cx="18.9" cy="13.9" r="0.5"/>
                <circle cx="18.9" cy="16.4" r="0.5"/>
                <circle cx="18.9" cy="18.9" r="0.5"/>
              </g>
              <g transform="rotate(45 -21.385 23)">
                <circle cx="1.4" cy="1.4" r="0.5"/>
                <circle cx="1.4" cy="3.9" r="0.5"/>
                <circle cx="1.4" cy="6.4" r="0.5"/>
                <circle cx="1.4" cy="8.9" r="0.5"/>
                <circle cx="1.4" cy="11.4" r="0.5"/>
                <circle cx="1.4" cy="13.9" r="0.5"/>
                <circle cx="1.4" cy="16.4" r="0.5"/>
                <circle cx="1.4" cy="18.9" r="0.5"/>
                <circle cx="3.9" cy="1.4" r="0.5"/>
                <circle cx="3.9" cy="3.9" r="0.5"/>
                <circle cx="3.9" cy="6.4" r="0.5"/>
                <circle cx="3.9" cy="8.9" r="0.5"/>
                <circle cx="3.9" cy="11.4" r="0.5"/>
                <circle cx="3.9" cy="13.9" r="0.5"/>
                <circle cx="3.9" cy="16.4" r="0.5"/>
                <circle cx="3.9" cy="18.9" r="0.5"/>
                <circle cx="6.4" cy="1.4" r="0.5"/>
                <circle cx="6.4" cy="3.9" r="0.5"/>
                <circle cx="6.4" cy="6.4" r="0.5"/>
                <circle cx="6.4" cy="8.9" r="0.5"/>
                <circle cx="6.4" cy="11.4" r="0.5"/>
                <circle cx="6.4" cy="13.9" r="0.5"/>
                <circle cx="6.4" cy="16.4" r="0.5"/>
                <circle cx="6.4" cy="18.9" r="0.5"/>
                <circle cx="8.9" cy="1.4" r="0.5"/>
                <circle cx="8.9" cy="3.9" r="0.5"/>
                <circle cx="8.9" cy="6.4" r="0.5"/>
                <circle cx="8.9" cy="8.9" r="0.5"/>
                <circle cx="8.9" cy="11.4" r="0.5"/>
                <circle cx="8.9" cy="13.9" r="0.5"/>
                <circle cx="8.9" cy="16.4" r="0.5"/>
                <circle cx="8.9" cy="18.9" r="0.5"/>
                <circle cx="11.4" cy="1.4" r="0.5"/>
                <circle cx="11.4" cy="3.9" r="0.5"/>
                <circle cx="11.4" cy="6.4" r="0.5"/>
                <circle cx="11.4" cy="8.9" r="0.5"/>
                <circle cx="11.4" cy="11.4" r="0.5"/>
                <circle cx="11.4" cy="13.9" r="0.5"/>
                <circle cx="11.4" cy="16.4" r="0.5"/>
                <circle cx="11.4" cy="18.9" r="0.5"/>
                <circle cx="13.9" cy="1.4" r="0.5"/>
                <circle cx="13.9" cy="3.9" r="0.5"/>
                <circle cx="13.9" cy="6.4" r="0.5"/>
                <circle cx="13.9" cy="8.9" r="0.5"/>
                <circle cx="13.9" cy="11.4" r="0.5"/>
                <circle cx="13.9" cy="13.9" r="0.5"/>
                <circle cx="13.9" cy="16.4" r="0.5"/>
                <circle cx="13.9" cy="18.9" r="0.5"/>
                <circle cx="16.4" cy="1.4" r="0.5"/>
                <circle cx="16.4" cy="3.9" r="0.5"/>
                <circle cx="16.4" cy="6.4" r="0.5"/>
                <circle cx="16.4" cy="8.9" r="0.5"/>
                <circle cx="16.4" cy="11.4" r="0.5"/>
                <circle cx="16.4" cy="13.9" r="0.5"/>
                <circle cx="16.4" cy="16.4" r="0.5"/>
                <circle cx="16.4" cy="18.9" r="0.5"/>
                <circle cx="18.9" cy="1.4" r="0.5"/>
                <circle cx="18.9" cy="3.9" r="0.5"/>
                <circle cx="18.9" cy="6.4" r="0.5"/>
                <circle cx="18.9" cy="8.9" r="0.5"/>
                <circle cx="18.9" cy="11.4" r="0.5"/>
                <circle cx="18.9" cy="13.9" r="0.5"/>
                <circle cx="18.9" cy="16.4" r="0.5"/>
                <circle cx="18.9" cy="18.9" r="0.5"/>
              </g>
              <g transform="rotate(45 10.293 14.121)">
                <circle cx="1.4" cy="1.4" r="0.5"/>
                <circle cx="1.4" cy="3.9" r="0.5"/>
                <circle cx="1.4" cy="6.4" r="0.5"/>
                <circle cx="1.4" cy="8.9" r="0.5"/>
                <circle cx="1.4" cy="11.4" r="0.5"/>
                <circle cx="1.4" cy="13.9" r="0.5"/>
                <circle cx="1.4" cy="16.4" r="0.5"/>
                <circle cx="1.4" cy="18.9" r="0.5"/>
                <circle cx="3.9" cy="1.4" r="0.5"/>
                <circle cx="3.9" cy="3.9" r="0.5"/>
                <circle cx="3.9" cy="6.4" r="0.5"/>
                <circle cx="3.9" cy="8.9" r="0.5"/>
                <circle cx="3.9" cy="11.4" r="0.5"/>
                <circle cx="3.9" cy="13.9" r="0.5"/>
                <circle cx="3.9" cy="16.4" r="0.5"/>
                <circle cx="3.9" cy="18.9" r="0.5"/>
                <circle cx="6.4" cy="1.4" r="0.5"/>
                <circle cx="6.4" cy="3.9" r="0.5"/>
                <circle cx="6.4" cy="6.4" r="0.5"/>
                <circle cx="6.4" cy="8.9" r="0.5"/>
                <circle cx="6.4" cy="11.4" r="0.5"/>
                <circle cx="6.4" cy="13.9" r="0.5"/>
                <circle cx="6.4" cy="16.4" r="0.5"/>
                <circle cx="6.4" cy="18.9" r="0.5"/>
                <circle cx="8.9" cy="1.4" r="0.5"/>
                <circle cx="8.9" cy="3.9" r="0.5"/>
                <circle cx="8.9" cy="6.4" r="0.5"/>
                <circle cx="8.9" cy="8.9" r="0.5"/>
                <circle cx="8.9" cy="11.4" r="0.5"/>
                <circle cx="8.9" cy="13.9" r="0.5"/>
                <circle cx="8.9" cy="16.4" r="0.5"/>
                <circle cx="8.9" cy="18.9" r="0.5"/>
                <circle cx="11.4" cy="1.4" r="0.5"/>
                <circle cx="11.4" cy="3.9" r="0.5"/>
                <circle cx="11.4" cy="6.4" r="0.5"/>
                <circle cx="11.4" cy="8.9" r="0.5"/>
                <circle cx="11.4" cy="11.4" r="0.5"/>
                <circle cx="11.4" cy="13.9" r="0.5"/>
                <circle cx="11.4" cy="16.4" r="0.5"/>
                <circle cx="11.4" cy="18.9" r="0.5"/>
                <circle cx="13.9" cy="1.4" r="0.5"/>
                <circle cx="13.9" cy="3.9" r="0.5"/>
                <circle cx="13.9" cy="6.4" r="0.5"/>
                <circle cx="13.9" cy="8.9" r="0.5"/>
                <circle cx="13.9" cy="11.4" r="0.5"/>
                <circle cx="13.9" cy="13.9" r="0.5"/>
                <circle cx="13.9" cy="16.4" r="0.5"/>
                <circle cx="13.9" cy="18.9" r="0.5"/>
                <circle cx="16.4" cy="1.4" r="0.5"/>
                <circle cx="16.4" cy="3.9" r="0.5"/>
                <circle cx="16.4" cy="6.4" r="0.5"/>
                <circle cx="16.4" cy="8.9" r="0.5"/>
                <circle cx="16.4" cy="11.4" r="0.5"/>
                <circle cx="16.4" cy="13.9" r="0.5"/>
                <circle cx="16.4" cy="16.4" r="0.5"/>
                <circle cx="16.4" cy="18.9" r="0.5"/>
                <circle cx="18.9" cy="1.4" r="0.5"/>
                <circle cx="18.9" cy="3.9" r="0.5"/>
                <circle cx="18.9" cy="6.4" r="0.5"/>
                <circle cx="18.9" cy="8.9" r="0.5"/>
                <circle cx="18.9" cy="11.4" r="0.5"/>
                <circle cx="18.9" cy="13.9" r="0.5"/>
                <circle cx="18.9" cy="16.4" r="0.5"/>
                <circle cx="18.9" cy="18.9" r="0.5"/>
              </g>
            </g>
          </g>
          <g fillRule="nonzero" stroke="#231F20" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5">
            <path d="M213.6 317.7c-.2 1.7-1.9 6.7-2.7 9.1l1.4-12.6c.4.4 1.6 1.6 1.3 3.5zM209.9 334.6c.1-.3.2-.7.3-1.1l.1-.6.3-2.3c.9.5 1 1.5 1 1.5.1 1.7-.9 2.3-1.7 2.5zM205.9 334.7c.1 1.7-.1 9.9-.9 13.3-.7 2.8-2.3 12.8-2.6 16-.218 2.322-.857 6.592-1.955 9.027a1.34 1.34 0 01-.045-.127c-.346-1.038-1.291-1.253-1.54-2.199-.158-10.489 5.84-31.701 5.84-31.701h0l1.156-5.641c0 .35.012.794.044 1.341zM203.306 380.995c.295.623.638 1.431.794 2.105.3 1.2-2.6 2-2.3 1.4.29-.436-.476-2.353-.916-3.366.457.154 1.021.2 1.716.066.211-.04.41-.095.597-.162z"/>
            <path d="M204.584 375.423c1.482 1.938.998 5.2-1.984 5.777-2.543.492-3.336-1.437-3.54-2.147 2.053 1.21 5.104-.471 5.44-2.153a5.32 5.32 0 00.09-1.385z"/>
            <path d="M204.5 376.9c-.5 2.5-7 5-7.3-2l.34-.255c.571 1.335 1.434 2.387 2.56 2.255 1.182-.139 1.735-1.051 1.963-1.594.3-.37.976-1.271 1.643-2.59.39.655 1.176 2.273.794 4.184z"/>
            <path d="M205.868 332.69c.068.178.145.349.232.51.4.9 1.1 1.5 2.2 1.7a11 11 0 00.146-.386l.054.186c1.3 4.6-1.5 17.5-1.5 17.5s-1.5 7.9-1.6 13.6c0 5.049-2.652 8.658-3.34 9.508.103-.24.14-.408.14-.408s-1.309-.654-1.757-1.873c1.1-2.435 1.74-6.705 1.957-9.027.3-3.2 1.9-13.2 2.6-16 .8-3.4 1-11.6.9-13.3a19.254 19.254 0 01-.031-1.99z"/>
            <path d="M198.8 370.2s-2.3.3-1.9 2.3c.4 2.1 1.5 4.6 3.2 4.4 1.7-.2 2.1-2 2.1-2s-1.4-.7-1.8-2c-.4-1.2-1.6-1.3-1.6-2.7zM211 315.7c-.8.3-1.7 3-1.8 4.3-.1 1.4-.8 4.8-1.2 8.8-.3 2.9.5 3.5.9 3.6v.2l-.1.6c-.1.6-.3 1.2-.5 1.7-1.1-.2-1.8-.8-2.2-1.7-1.3-2.4-.3-6.8.4-10.9.9-5.5 1.2-5.1 2.2-7.3.1-.3.3-.6.5-.8 1-1.3 2-.9 2.1-.8l-.3 2.3z"/>
            <path d="M209.3 314.1c-.2.2-.3.5-.5.8-1.1 2.2-1.4 1.8-2.2 7.3-.6 4.1-1.7 8.5-.4 10.9-.4.3-1 .6-2.1.3-1.9-.5-.3-5.8 0-9.6s1.1-6.9 1.1-6.9c1.3-4 4.1-2.8 4.1-2.8zM197 373.2c.15.6.327 1.09.495 1.48l-.295.22c.018.418.058.801.117 1.153-.12.001-.414-.159-1.117-1.053-.931-1.397.565-1.753.776-1.795z"/>
          </g>
        </g>
      </g>
    ) : (
      <g id="zipper_puller_hard" fillRule="nonzero">
        <path d="M158.1 244.6c4.884 1.053 26.187 15.407 29.56 20.22.416-.092.74-.265.74-.52 0-.4 7.5-.3 8.4 6.8l.001.375c.108.295.208.603.299.925l-1.6-1s-.011-.032-.034-.09c.217 1.378.334 2.59.334 2.59s-.444.144-1.058.316l1.758.984c-9 2.5-13-7.3-13-7.3l1.161-.412-.025-.03c-2.08.709-3.732 1.156-5.036 1.342l-.6-1.8c1.15 0 2.422-.082 3.66-.35-1.93-1.96-12.026-11.778-28.06-19.75 0 0-2.2-1.5-1.1-1.9a.276.276 0 01.126-.014l-.126-.086s-.5-1.4 4.6-.3z" fill={fillColor}/>
        <g stroke={strokeColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5">
          <path d="M158.1 244.6c4.884 1.053 26.187 15.407 29.56 20.22-.237.053-.505.08-.76.08-.7 0-1.2.5-1.2.5a7.969 7.969 0 011.676.044c-1.08.068-2.02.289-2.676.556-.12.053-.241.104-.364.152l-.04.016c-8.683-9.783-28.618-21.054-30.67-21.182l-.126-.086s-.5-1.4 4.6-.3z"/>
          <path d="M184.296 266.167l-.33.122c-.426.147-.864.266-1.305.362-1.93-1.961-12.027-11.779-28.061-19.751 0 0-2.2-1.5-1.1-1.9 1.092-.496 21.878 11.12 30.796 21.167zM196.8 271.1v.372c-1.875-5.11-6.25-6.228-9.425-6.028a7.9 7.9 0 00-1.675-.044s.5-.5 1.2-.5 1.5-.2 1.5-.6c0-.4 7.5-.3 8.4 6.8z"/>
          <path d="M197.1 272.4l-1.6-1s-2.4-6.9-10.4-4.1c-2.3.8-4.1 1.3-5.5 1.5l-.6-1.8c1.8 0 3.9-.2 5.7-1 2.7-1.1 10.2-1.4 12.4 6.4z"/>
          <path d="M194 273.8s-4 1.6-8.8-6.5l-1.7.6s4 9.8 13 7.3l-2.5-1.4z"/>
        </g>
        <g stroke="#30292B" strokeLinecap="round" strokeLinejoin="round">
          <g strokeWidth=".324">
            <path d="M35.81 17.489l-6.6-.1-3.9-.2c-.5-.3-3.9-.4-3.9-.4l-.6-.5 10.9.3 4.1.9z" fill="url(#e)" transform="translate(187.49 266.811)"/>
            <path d="M24.31 15.789l-3.5.1s-.5-3.2 2.3-3.7 5.8-.2 7.6 0c1.4.2 4.6 1.4 4.2 5l-3.5.1s1.3-2.5-1.5-3.4c.1 0-5.3-1.3-5.6 1.9z" fill="url(#ff)" transform="translate(187.49 266.811)"/>
            <path fill="url(#gg)" d="M21.41 16.689v2.6h-.6v-3.1z" transform="translate(187.49 266.811)"/>
            <path d="M23.51 16.789l.1 2.8c-.2 0-.4-.1-.5-.1l-1.7-.2v-2.6s1.1.1 2.1.1z" fill="url(#hh)" transform="translate(187.49 266.811)"/>
            <path d="M25.31 17.089l.1 2.8c-.7 0-1.3-.1-1.8-.2l-.1-2.8c.8 0 1.6.1 1.8.2z" fill="url(#ii)" transform="translate(187.49 266.811)"/>
            <path fill="url(#jj)" d="M35.81 17.489v.9l-6.3.1v1.5h-.5l-.1-2.7h.3z" transform="translate(187.49 266.811)"/>
            <path d="M28.91 17.289l.1 2.7h-.3s-1.8 0-3.4-.1l-.1-2.8 3.7.2z" fill="url(#kk)" transform="translate(187.49 266.811)"/>
            <path d="M25.91 15.589c-1.5.6-4.1-.7-4.1-.7l-1.2-.7-15.9-8.7s-.5-.3-1.2-.7c-1.3-.7-3.1-1.9-3.4-2.5-.4-.8.4-1.9.6-2.2 0 0 .9-.2 1.2 0-1.3 1.1 1.2 2.6 1.2 2.6l.4.2 2.6 1.5 13 7.2 2.2 1.2 2.7 1.5c.5.3.9 0 .9 0l.9.5c.6.4.1.8.1.8z" fill="url(#ll)" transform="translate(187.49 266.811)"/>
            <path d="M8.81 2.189l14.3 9.9-1.8.8-18.3-10.2s-2.4-1.3-1.2-2.6l2.1.6c-.1.3-.1 1.8 4.1 3.8" fill="url(#mm)" transform="translate(187.49 266.811)"/>
          </g>
          <path d="M11.4 5.2h0v-.1c0-.5-.1-1.4-.6-1.9-.6-.6-2.3-2.5-4-2.4 0 0-.6-.1-1.5.6-.8.7-4 .3-4 .3S1.1 2.9 1.1 5h0v.2h0c0 1.7.2 3.3.2 3.3s3.2-.4 4 .3c.8.7 1.5.6 1.5.6 1.7.1 3.4-1.8 4-2.4.5-.5.5-1.4.6-1.9v.1s0 0 0 0z" strokeWidth=".324" fill="url(#n)" transform="translate(203 306)"/>
          <path d="M8.5 1.2c-.3-.1-.7-.2-1.1-.1 0 0-.7-.1-1.6.6-.7.6-3.3.5-4.6.4 0-.2.1-.4.1-.4s3.2.4 4-.3C6.1.7 6.8.8 6.8.8c.6-.1 1.2.1 1.7.4z" strokeWidth=".324" fill="url(#o)" transform="translate(203 306)"/>
          <path d="M10.6 4.3V7c-.2 0-.6.1-1.1.1V7h0c.1-1.1-.2-2.1-.9-2.7h2z" strokeWidth=".324" fill="url(#p)" transform="translate(203 306)"/>
          <path d="M9.8 7c.2-1.7-1-3.2-2.6-3.4-1.7-.2-3.2 1-3.4 2.6L.3 23.8c-.4 2.7 1 5.1 3.7 5.4 2.7.4 4.6-1.6 5-4.3L9.8 7zM4 28.7C1.6 28.4.4 26.3.8 23.9l2.3-12.1 1.2-5.5c.2-1.4 1.5-2.4 2.9-2.2 1.4.2 2.4 1.5 2.2 2.8l-.3 5.6-.6 12.4C8.1 27.3 6.4 29 4 28.7z" strokeWidth=".198" fill="url(#q)" transform="translate(203 306)"/>
          <path d="M4.9 21.2c-1.8-.2-3.5 1.1-3.8 3.1-.3 2 1 3.7 2.8 4 1.8.2 3.5-1.1 3.8-3.1.4-2-.9-3.8-2.8-4z" strokeWidth=".198" fill="url(#r)" transform="translate(203 306)"/>
          <path d="M8.9 12.5l.3-5.6c.2-1.4-.8-2.7-2.2-2.8-1.4-.1-2.7.8-2.9 2.2l-1.2 5.5L.6 23.9c-.3 2.4.9 4.5 3.2 4.8 2.4.3 4.1-1.4 4.4-3.8l.7-12.4zM7 4.6c1.1.1 1.8 1.5 1.6 3-.2 1.5-1.2 2.6-2.3 2.5-1.1-.1-1.8-1.5-1.6-3C4.9 5.6 5.9 4.5 7 4.6zM4 28.2c-1.8-.2-3.1-2-2.8-4 .3-2 2-3.3 3.8-3.1 1.8.2 3.1 2 2.9 4-.4 2-2.1 3.4-3.9 3.1z" strokeWidth=".198" fill="url(#s)" transform="translate(203 306)"/>
          <path d="M9.2 6.9c.2-1.4-.8-2.7-2.2-2.8-1.4-.1-2.7.8-2.9 2.2l-1.2 5.5c.7-.7 1.9-1.1 3.1-1 1.3.2 2.3.8 2.8 1.7l.4-5.6zm-2.9 3.2c-1.1-.1-1.8-1.5-1.6-3C4.9 5.6 5.9 4.5 7 4.6c1.1.1 1.8 1.5 1.6 3-.2 1.5-1.3 2.6-2.3 2.5z" strokeWidth=".198" fill="url(#t)" transform="translate(203 306)"/>
          <path d="M8.4 7.1H4c-1.5-.1-2.5-.5-2.5-.5-.2-.8-.1-2.6-.1-2.6.8.1 2.4.2 4 .2H7c.9.3 1.4 1.5 1.4 2.9z" strokeWidth=".324" fill="url(#u)" transform="translate(203 306)"/>
          <path strokeWidth=".198" fill="url(#v)" d="M3.3 19.1l-.5-.9.5.1.2.5.4-.4.5.1-.7.8-.1.8-.4-.1z" transform="translate(203 306)"/>
          <path strokeWidth=".198" fill="url(#w)" d="M5 19.1l.6-.6.5.1-.8.7.6 1-.6-.1-.5-.8-.1.7-.4-.1.2-1.6.4.1z" transform="translate(203 306)"/>
          <path strokeWidth=".198" fill="url(#x)" d="M6.7 19.4l.6-.6.5.1-.8.7.6 1-.6-.1-.5-.8-.1.7-.4-.1.2-1.6.4.1z" transform="translate(203 306)"/>
        </g>
        <path d="M203.1 329.3c1.5-1.8 4.8-1.3 4.8-1.3s3.2.4 4.3 2.5c0 0 .3.3-.1 1.7-.32.897-.517 3.107-1.853 4.422-.84 6.5-2.923 22.747-3.647 28.378-.3 2.6-2 4.2-4 4h-.2c-1.9-.3-3.1-2.3-2.8-4.8.735-5.714 2.935-22.357 3.773-28.714-.753-1.581-.413-3.58-.473-4.486-.1-1.5.2-1.7.2-1.7z" fill={fillColor}/>
        <g stroke={strokeColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5">
          <path d="M205.1 331c.8-.1 2.4.1 2.4.1s1.6.2 2.3.5c1.1.5 1.1.8 1.1.8h0l-.46-.06c.13.37.288.986.16 1.56-.1.7-3.1 24.1-4 31.1-.3 2.6-2 4.2-4 4h-.2 0c-1.9-.3-3.1-2.3-2.8-4.8.9-7 4-30.4 4.1-31.2.062-.555.352-1.11.565-1.455l-.365-.045s.1-.4 1.2-.5z"/>
          <path d="M207.9 328s3.2.4 4.3 2.5c0 0 .3.3-.1 1.7-.32.897-.518 3.108-1.854 4.423a1431.587 1431.587 0 01.354-2.723 1.84 1.84 0 00.012-.056l-.012.056a1.914 1.914 0 00.047-.437 2.515 2.515 0 00-.004-.17 3.173 3.173 0 00-.083-.545 3.902 3.902 0 00-.066-.242l-.01-.033h0l-.006-.018a4.102 4.102 0 00-.026-.08l-.012-.034.46.059c-.003-.032-.058-.326-1.1-.8-.7-.3-2.3-.5-2.3-.5s-1.6-.2-2.4-.1c-1.1.1-1.2.5-1.2.5h0l.365.045a5.342 5.342 0 00-.087.146 4.502 4.502 0 00-.333.708 3.227 3.227 0 00-.102.346l-.01.047h0l-.004.021c-.012.059-.02.117-.028.176l-.001.011-.05.392-.006.04a886.45 886.45 0 01-.24 1.821l-.03.226c-.754-1.574-.414-3.573-.474-4.479-.1-1.5.2-1.7.2-1.7 1.5-1.8 4.8-1.3 4.8-1.3z"/>
        </g>
      </g>
    )}
  </g>
)

export default SaZipperPuller